import styled from 'styled-components';
import Icon from 'helpers/svg-icon';
import { grey70 } from 'constants/variables';

type Direction = 'left' | 'right' | 'up' | 'down';

interface IconBaseProps {
  width?: number;
  height?: number;
  fillColor?: string;
  className?: string;
  title?: string;
}

interface DirectionalIconProps extends IconBaseProps {
  direction?: Direction;
}

const ZoomIcon = ({
  width = 12,
  height = 12,
  fillColor,
  className,
  ...rest
}: IconBaseProps) => (
  <Icon
    viewBox="0 0 11.999995262659533 12.000009736367582"
    width={width}
    height={height}
    className={className}
    {...rest}>
    <g transform="translate(0, 0)" fill={fillColor}>
      <g transform="translate(-0.000004737340466409723, -0.000010263632421042557) rotate(0)">
        <path
          d="M12,10.42509l-2.89198,-3.03384c1.30379,-2.10118 0.80664,-4.83363 -1.15628,-6.35521c-1.96292,-1.52158 -4.76885,-1.34955 -6.5261,0.40013c-1.75725,1.74967 -1.90831,4.52187 -0.35133,6.44765c1.55698,1.92578 4.32801,2.39415 6.44494,1.08936l2.88591,3.02684zM1.70895,4.86338c0,-1.28406 0.7835,-2.44161 1.98499,-2.93262c1.20148,-0.49101 2.5842,-0.21874 3.50307,0.6898c0.91888,0.90854 1.19285,2.27432 0.69411,3.46017c-0.49874,1.18585 -1.67192,1.95811 -2.97223,1.95649c-1.77346,-0.00221 -3.20994,-1.42254 -3.20994,-3.17383z"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <defs>
        <path
          id="path-16524286000692099"
          d="M12,10.42509l-2.89198,-3.03384c1.30379,-2.10118 0.80664,-4.83363 -1.15628,-6.35521c-1.96292,-1.52158 -4.76885,-1.34955 -6.5261,0.40013c-1.75725,1.74967 -1.90831,4.52187 -0.35133,6.44765c1.55698,1.92578 4.32801,2.39415 6.44494,1.08936l2.88591,3.02684zM1.70895,4.86338c0,-1.28406 0.7835,-2.44161 1.98499,-2.93262c1.20148,-0.49101 2.5842,-0.21874 3.50307,0.6898c0.91888,0.90854 1.19285,2.27432 0.69411,3.46017c-0.49874,1.18585 -1.67192,1.95811 -2.97223,1.95649c-1.77346,-0.00221 -3.20994,-1.42254 -3.20994,-3.17383z"
          vectorEffect="non-scaling-stroke"
        />
      </defs>
    </g>
  </Icon>
);

const ChevronChange = styled(Icon)<{ direction?: Direction; title?: string }>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  transform: ${({ direction }) =>
    ({
      left: 'rotate(90deg)',
      right: 'rotate(-90deg)',
      down: 'rotate(0deg)',
      up: 'rotate(180deg)',
    }[direction || 'down'] || 'none')};
`;

const ChevronIcon = ({
  fillColor = grey70,
  width = 10,
  height = 6,
  title,
  direction = 'down',
  className,
  ...rest
}: DirectionalIconProps) => (
  <ChevronChange
    height={height}
    width={width}
    viewBox="0 0 9.586 5.615"
    title={title}
    direction={direction}
    className={className}
    {...rest}>
    <path
      d="M519.655,364.084l-.823-.823-3.97,3.97-3.97-3.97-.823.823,4.793,4.793Z"
      transform="translate(-510.069 -363.262)"
      fill={fillColor}
    />
  </ChevronChange>
);

const ArrowChange = styled(Icon)<{ direction?: Direction }>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  margin-left: 8px;
  transform: ${({ direction }) =>
    ({
      left: 'rotate(180deg)',
      right: 'rotate(0deg)',
      down: 'rotate(90deg)',
      up: 'rotate(-90deg)',
    }[direction || 'down'] || 'none')};
`;

interface ArrowProps extends DirectionalIconProps {
  isHidden?: boolean;
}

const Arrow = ({
  fillColor,
  direction = 'right',
  isHidden,
  width = 9,
  height = 15,
  ...rest
}: ArrowProps) => (
  <ArrowChange
    transform={isHidden ? 'rotate(90)' : 'rotate(-90)'}
    width={width}
    height={height}
    direction={direction}
    viewBox="0 0 9 15"
    {...rest}>
    <path
      d="M0 11.829l4.96-4.96L0 1.909 1.913-.004l6.872 6.872-6.872 6.877z"
      fill={fillColor}
    />
  </ArrowChange>
);

export { ZoomIcon, Arrow, ChevronIcon };
